import {WidgetParameter} from "@/components/widgets/WidgetFather"

export function getParameterValue(parameter: WidgetParameter) {
  if (Object.keys(parameterProcessors).indexOf(parameter?._inputType) > -1) {
    const fn = parameterProcessors[parameter._inputType]
    return fn(parameter)
  } else {
    console.error("Unknown input type:", parameter?._inputType)
    return undefined
  }
}

export function getParameterValueTitle(parameter: WidgetParameter) {
  if (Object.keys(parameterProcessors).indexOf(parameter?._inputType) > -1) {
    const fn = parameterProcessors[parameter._inputType+"Title"]
    return fn(parameter)
  } else {
    console.error("Unknown input type:", parameter?._inputType)
    return undefined
  }
}

const parameterProcessors: any = {
  InputEnum(parameter: WidgetParameter) {
    if (typeof parameter === "object" &&
      typeof parameter.value !== "undefined" &&
      typeof parameter.value.value !== "undefined") {
      return parameter.value.value
    } else {
      return parameter._default.value
    }
  },
  InputEnumTitle(parameter: WidgetParameter) {
    if (typeof parameter === "object" &&
      typeof parameter.value !== "undefined" &&
      typeof parameter.value.title !== "undefined") {
      return parameter.value.title
    } else {
      return parameter._default.title
    }
  },
}
